/**
 * 每日首次进入系统时触发竞价投放数据预加载（后台静默），
 * 用户进入竞价投放页时可优先使用缓存以加快首屏。
 */
import { triggerAccountReportSyncAsync } from '@/api/accountReportSchedule'
import {
  hasMenuCode,
  isPermissionsReady,
  getFirstAllowedBiddingPlatform
} from '@/utils/userPermission'

const PRELOAD_DATE_KEY = 'bidding_preload_date'
const WARMUP_SUBMIT_DATE_KEY = 'bidding_warmup_submit_date'
let warmupSubmitting = false

function getTodayDateKey() {
  return new Date().toISOString().slice(0, 10)
}

/** 今日是否已执行过预加载 */
export function hasPreloadedToday() {
  return localStorage.getItem(PRELOAD_DATE_KEY) === getTodayDateKey()
}

/** 标记今日已触发预加载 */
export function setPreloadedToday() {
  try {
    localStorage.setItem(PRELOAD_DATE_KEY, getTodayDateKey())
  } catch (e) {
    // ignore
  }
}

function hasWarmupSubmittedToday() {
  return localStorage.getItem(WARMUP_SUBMIT_DATE_KEY) === getTodayDateKey()
}

function setWarmupSubmittedToday() {
  try {
    localStorage.setItem(WARMUP_SUBMIT_DATE_KEY, getTodayDateKey())
  } catch (e) {
    // ignore
  }
}

/**
 * 每日首次进入系统时，提交一次“全经理户+全维度”的后台异步预热任务。
 * 不阻塞路由；失败后可在后续路由切换时自动重试。
 */
function runBiddingWarmupIfNeeded() {
  if (!hasMenuCode('bidding-delivery') && !hasMenuCode('account-report-schedule')) return
  if (hasWarmupSubmittedToday()) return
  if (warmupSubmitting) return
  warmupSubmitting = true
  triggerAccountReportSyncAsync({
    // managerAccountId 为空时由后端按配置/配置表解析全部经理户
    onlyWithSpending: true,
    includeAccount: true,
    includePlan: true,
    includeTask: true,
    includeCreative: true
  }).then(() => {
    setWarmupSubmittedToday()
  }).catch(() => {
    // ignore：保留重试机会
  }).finally(() => {
    warmupSubmitting = false
  })
}

/**
 * 若今日尚未预加载，则标记并触发一次后台预加载（不阻塞路由）。
 * @param {import('vuex').Store} store
 */
export function runBiddingPreloadIfNeeded(store) {
  if (!hasMenuCode('bidding-delivery')) return
  if (!isPermissionsReady()) return
  const platformType = getFirstAllowedBiddingPlatform()
  if (!platformType) return
  runBiddingWarmupIfNeeded()
  if (hasPreloadedToday()) return
  setPreloadedToday()
  store.dispatch('biddingPreload/runPreload', { platformType }).catch(() => {})
}

export function canRunBiddingPreload() {
  if (!hasMenuCode('bidding-delivery') || !isPermissionsReady()) return false
  return !!getFirstAllowedBiddingPlatform()
}

export { getTodayDateKey }
